import axios from 'axios';
import store from '../redux/store/store';
const API_BRAND_URL = import.meta.env.VITE_API_URL;

const brandSevice = {
  // MARKA işlemleri
  updateBrandApi: (data, token) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    return axios.put(
      `${API_BRAND_URL}/Brand`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
  },

  getBrandApi: (userId, token, page=1, searchTerm = "") => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    const queryParams = new URLSearchParams({
      userId: userId,
      withMarketpleacesBrand: true,
      page: page,
      search: searchTerm
    });

    return axios.get(
      `${API_BRAND_URL}/Brand?${queryParams.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
      }
    );
  },



  addBrandApi: (data, token) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    return axios.post(`${API_BRAND_URL}/Brand`,
      data,
      {
        headers: {
          Authorization: `Bearer ${userToken}`
        }
      });
  },


  deleteBrandApi: (id, token) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    return axios.delete(`${API_BRAND_URL}/Brand`, {
      params: { Id: id },
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    });
  },


  getBrandDetailApi: (id, token) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    const queryParams = new URLSearchParams({
      Id: id,
      withMarketpleacesBrand: true
    });

    return axios.get(
      `${API_BRAND_URL}/Brand?${queryParams.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json'
        }
      }
    );
  },



  getBrandForDropdown: (userId) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    const queryParams = new URLSearchParams({
      userId: userId,
      ClosePagination: true,
    });

    return axios.get(
      `${API_BRAND_URL}/Brand?${queryParams.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
      }
    );
  },


};




export default brandSevice;
